export default [
  { text: 'Male', value: 'male' },
  { text: 'Female', value: 'female' },
]
